import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { HelperService } from 'app/services/helper.service';
import { NgForm } from '@angular/forms'; 
import { AssessmentMasterService } from "../../services/assesment-master.service";

@Component({
    selector: 'app-assessment-master-edit-view-new-modal',
    templateUrl: './assessment-master-edit-view-new-modal.component.html',
    styleUrls: ['./assessment-master-edit-view-new-modal.component.scss'],
    providers: [AssessmentMasterService]
})


export class AssessmentMasterEditViewAddQuestionModalComponent implements OnInit {
    public masterData: any = {};
    formData = {
        qiz_type_id: '',
        marks: '',
        sort: '',
        question: '',
        can_type_answer:'',
        can_alter_quesion: '',
        auto_id: ''
    };
    activeStatus = [
        {value: 1, label: 'Active'},
        {value: 0, label: 'Not Active'},
      ];
    alterType = [
        { value: 0, label: "No" },
        { value: 1, label: "Yes" },
      ];
    answerType = [
        { value: 0, label: "No" },
        { value: 1, label: "Yes" },
      ];

    isEdit: number;
    @Output() tableReload: EventEmitter<any> = new EventEmitter();
    @Input() auto_id: number;

    @ViewChild('form') form: NgForm;
    @ViewChild('swalModal') swalModal: any;
    @ViewChild('errorMessageHtml') errorMessageHtml: any;

    public successMsg: string = '';
    public htmlErrorMessage: string = "";
    selectedCompanySystemID = this.helperService.getSelectedCompanyId();
    companySystemID = +this.helperService.getSelectedCompanyId();


    

    constructor(
        public bsModalRef: BsModalRef,
        private helperService: HelperService,
        private modalService: BsModalService,
        private AssessmentMasterService: AssessmentMasterService,) {
    }

    ngOnInit() {
        this.auto_id = Number(localStorage.getItem("assessment-master-edit-auto-id"));
        localStorage.removeItem("assessment-master-edit-auto-id");
        //console.log(this.auto_id);
      }

    showErrorHtml() {
        setTimeout(() => {
            this.errorMessageHtml.show();
        }, 0)
    }

    closeModal() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason('designation_closed');
    }

    closeModalAfterCreate() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason('designation_closed');
    }

    showSuccessHtml() {
        setTimeout(() => {
            this.swalModal.show();
        }, 0);
    }






    // addNewQuestionsHeaders(formData: any) {
    //     //console.log("hiii");

    //     const requestData = {
    //         qiz_type_id: formData.qiz_type_id,
    //         marks: formData.marks,
    //         sort: formData.sort,
    //         question: formData.question,
    //         can_type_answer: formData.can_type_answer,
    //         can_alter_quesion: formData.can_alter_quesion,
    //         company_id: this.companySystemID,
    //         header_id: this.auto_id,
    //     };
    //     //console.log(requestData);

    //     let that = this;
    //     that.masterData.companySystemID = that.companySystemID;
    //     that.masterData.header_id = that.auto_id;
    //     that.AssessmentMasterService
    //     .createNewQuestionHeader()
    //     .post(requestData)
    //     .subscribe(
    //         (resp: any) => {
    //             //console.log(resp);
    //             that.masterData = {};
    //             that.successMsg = '';
    //             that.successMsg = 'Successfully added a new question';
    //             that.showSuccessHtml();
    //             that.closeModalAfterCreate();
    //             this.tableReload.emit();
    //         },
    //         (error) => {
    //             that.htmlErrorMessage = '';
    //             if (error.status == 500) {
    //                 that.htmlErrorMessage = error.data.message;
    //                 that.showErrorHtml();
    //             } else if (error.status == 422) {
    //                 that.htmlErrorMessage = that.helperService.serverSideError422(error.data.message);
    //                 that.showErrorHtml();
    //             }
    //             this.tableReload.emit();
    //         }
    //     );
    // }


}



// WEBPACK FOOTER //
// /app/src/app/competancy/assessment-master-edit-view-new-modal/assessment-master-edit-view-new-modal.component.ts